import { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import classNames from 'classnames';
import { AlignContainer, BaseSpinner } from 'wbs-components-lib';

import { Box, Typography } from '@mui/material';

import { useGetBetOutcomesQuery } from '@services';

import { AppDispatch, getBetOutcomesByEventIdSelector, setBetOutcomes } from '@store';

import { BetSystemEventOutcome } from './BetSystemEventOutcome/BetSystemEventOutcome';
import { BetSystemEventOutcomesProps } from './types';

import styles from './BetSystemEventOutcomes.module.css';

const { betEventOutcomesContainer, betEventOutcomesEmptyContainer } = styles;

export const BetSystemEventOutcomes: FC<BetSystemEventOutcomesProps> = ({
  betEventId,
  betEventName,
  isOutcomesExpanded,
}) => {
  const dispatch = useDispatch<AppDispatch>();

  const currentBetEventOutcomes = useSelector(getBetOutcomesByEventIdSelector(betEventId));

  const isBetEventOutcomesEmpty = currentBetEventOutcomes.length === 0;

  const { data: betEventOutcomes, isLoading: isOutcomesLoading } = useGetBetOutcomesQuery(betEventId, {
    refetchOnMountOrArgChange: true,
    skip: !isBetEventOutcomesEmpty || !isOutcomesExpanded,
  });

  useEffect(() => {
    if (betEventOutcomes !== undefined) {
      dispatch(setBetOutcomes({ betEventOutcomes, betEventId }));
    }
  }, [betEventOutcomes]);

  return (
    <Box
      className={classNames(betEventOutcomesContainer, {
        [betEventOutcomesEmptyContainer]: isBetEventOutcomesEmpty,
      })}
    >
      {!isOutcomesLoading ? (
        <>
          {!isBetEventOutcomesEmpty ? (
            <>
              {currentBetEventOutcomes.map((betEventOutcome) => (
                <BetSystemEventOutcome
                  key={betEventOutcome.id}
                  betEventName={betEventName}
                  betEventOutcome={betEventOutcome}
                />
              ))}
            </>
          ) : (
            <Typography align="center">No outcomes</Typography>
          )}
        </>
      ) : (
        <AlignContainer>
          <BaseSpinner />
        </AlignContainer>
      )}
    </Box>
  );
};
